var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { inputBaseClasses } from '@mui/material/InputBase';
export var createMuiInputBaseOverrides = function (_a) {
    var _b;
    var spacing = _a.spacing, typography = _a.typography, tokens = _a.tokens;
    return {
        defaultProps: {
            color: 'primary',
        },
        styleOverrides: {
            root: __assign(__assign({}, typography.input), (_b = {}, _b["&.".concat(inputBaseClasses.disabled)] = {
                backgroundColor: tokens.color_bg_input_disabled,
                color: tokens.color_fg_disabled,
            }, _b)),
            inputMultiline: __assign({}, typography.body2),
            input: {
                // use line height and padding for height
                height: 'unset',
                padding: spacing(1.125, 2),
            },
            sizeSmall: {
                margin: 0,
            },
            inputSizeSmall: {
                paddingTop: 5,
                paddingBottom: 5,
            },
        },
    };
};
